const extractProductTags = (product: any, tagName: string): string[] => {
  return product.tags.filter((tag: string) => tag.toLowerCase().includes(tagName.toLowerCase()));
};

export default extractProductTags;